var jade = require("/home/runner/work/banquetNinja/banquetNinja/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<div layout=\"row\"><div flex=\"50\"><ninja-grid no-data-text=\"No rooms assigned yet...\" grid-title=\"Event Rooms\" doc-svc=\"vm.docSvc\" list=\"vm.docSvc.doc.venues\" create-method=\"addVenue\" update-method=\"\" delete-method=\"removeVenue\" add-toggle=\"vm.sideTab.rooms\" fields=\"{name: {input: 'text', header: 'Room Name', order: 10, width: 20, type: 'string'}, \n                    notes: {input: 'text', header: 'Event Room Notes', order: 20, width: 50, type: 'string'},\n                    price: {input: 'text', header: 'Room Minimum', order: 30, width: 20, type: 'number'}}\"></ninja-grid></div><div flex=\"50\"><div layout=\"column\" class=\"itemCardHeader\"><h4>Table Map(s)</h4></div><div class=\"gridItemCell\"><p>This could maybe be where a table map image or links to the outstide serviec is added</p></div></div></div>");;return buf.join("");
}


//////////////////
// WEBPACK FOOTER
// ./app/features/events/contracts/tabs/tab-rooms.jade
// module id = 271
// module chunks = 0